module.exports = __webpack_public_path__ + "static/media/connections.a0ff647c.svg";